export default __webpack_public_path__ + "static/media/chat8.a6a78177.jpg";